<template>
  <nav class="navbar navbar-expand-lg navbar--primary">
    <div class="container">
      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <router-link tag="li" to="/admin/dashboard" class="nav-item">
            <a class="nav-link" href="#">Dashboard</a>
          </router-link>
          <li v-if="hasPermission('view-flow-tables')" class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Flow Tables
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link
                class="dropdown-item"
                :to="{ name: 'PaydirectNotifications' }"
              >
                Pay Direct Notifications
              </router-link>
              <router-link to="/admin/payments" class="dropdown-item"
                >Payments</router-link
              >
              <router-link to="/admin/cbs-paydirect" class="dropdown-item"
                >CBS Paydirect</router-link
              >
              <router-link v-if="hasPermission('act-on-cbsqueue')" to="/admin/cbs-queue" class="dropdown-item"
                >CBS Queue</router-link
              >
              <router-link to="/admin/preservice-bills" class="dropdown-item"
                >Pre Service Bills</router-link
              >
              <router-link to="/admin/cbs-poa" class="dropdown-item"
                >CBS POA</router-link
              >
              <router-link to="/admin/bill-settlement" class="dropdown-item"
                >Bill Settlement</router-link
              >
              <router-link to="/admin/unprocessed" class="dropdown-item"
                >Unprocessed</router-link
              >
              <router-link
                to="/admin/webpay-notifications"
                class="dropdown-item"
                >Webpay Notifications</router-link
              >
            </div>
          </li>
          <li v-if="hasPermission('users_manage')" class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              User Management
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link to="/admin/permissions" class="dropdown-item"
                >Permissions</router-link
              >
              <router-link to="/admin/roles" class="dropdown-item"
                >Roles</router-link
              >
              <router-link to="/admin/users" class="dropdown-item"
                >Users</router-link
              >
            </div>
          </li>
          <li v-if="hasPermission('view-reports')" class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Reports
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <!-- <router-link to="/admin/general-report" class="dropdown-item">General Collections Report</router-link> -->
              <router-link to="/admin/revenue-report" class="dropdown-item"
                >Revenue Collections Report</router-link
              >
              <router-link to="/admin/monthly-report" class="dropdown-item"
                >Monthly Collections Report</router-link
              >
              <router-link to="/admin/yearly-report" class="dropdown-item"
                >Yearly Collections Report</router-link
              >
              <router-link to="/admin/bank-report" class="dropdown-item"
                >Bank Collections Report</router-link
              >
              <router-link to="/admin/reversed-report" class="dropdown-item"
                >Reversed Collections Report</router-link
              >
              <router-link to="/admin/channel-report" class="dropdown-item"
                >Channel Collections Reports</router-link
              >
            </div>
          </li>
          <li v-if="hasPermission('troubleshoot')" class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              Utilities
            </a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown">
              <router-link to="/admin/failed-poa" class="dropdown-item"
                >Failed Pay On Account</router-link
              >
              <router-link to="/admin/failed-settlement" class="dropdown-item"
                >Failed Settlements</router-link
              >
            </div>
          </li>
          <li class="nav-item">
            <a
              class="nav-link"
              href="https://payment.eirs.gov.ng/webpay"
              target="_blank"
              rel="noopener noreferrer"
              >Webpay</a
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      isLoadingPage: false,
      roles: [],
      permissions: [],
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    async fetchRoles() {
      try {
        const { data: roles } = await this.$repos.userManagementRepo.getRoles();
        this.roles = roles;
      } catch (error) {
        console.log(error);
      } finally {
        this.isLoadingPage = false;
      }
    },

    hasPermission(permissionName) {
      const userRoleIds = this.user?.roles?.map((role) => role.id);
      const userRoles = this.roles?.filter((role) =>
        userRoleIds.includes(role.id)
      );

      const allPermissions = userRoles
        .flatMap((role) => role?.permissions)
        .map((p) => p.name);

      return allPermissions?.includes(permissionName);
    },
  },

  async mounted() {
    await this.fetchRoles();
  },
};
</script>

<style lang="scss">
.navbar--primary {
  background-color: $primary;
  .nav-link {
    color: $white;
  }
}
.dropdown-menu {
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1), 0 3px 6px rgbaa(0, 0, 0, 0.22) !important;
}
</style>
